
























































import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import draggable from 'vuedraggable'
import PlayPane from './playPane.vue'
import { iconMap } from '@/util/resMap'
import { getCateList, getGeneralCateList, getSubCateList, queryList } from '@/api/res'
import { MapType, IdName } from '@/util/types'
import { toMap } from '@/fn/array'
import { Pagination, Input, Button } from 'ant-design-vue'
import { gotoRoute } from '@/util/intent'
import { shrinkSetData } from '@/util/dragThumb'

interface Filter {
  label: string
  key: string
  list: IdName[]
}

const withAll = (list: IdName[]) => {
  return list && list.length > 0 ? [{ id: 0, name: '全部' }].concat(list || []) : []
}

// 属性列表，TODO: 应该后端提供
const cateTypeList: IdName[] = [
  { id: 0, name: '全部' },
  { id: 1, name: '学科属性' },
  { id: 2, name: '自然属性' }
]
const cateTypeMap = toMap(cateTypeList, 'id', 'name')

const defaultQuery: any = {
  resType: 0,

  cateType: 0,
  phase: 0,

  generalCate: 0,
  generalSubCate: 0,

  subject: 0,
  grade: 0,

  newKnowCate: 0,
  volume: 0,

  keyword: '',
  page: 1
}

const makeQuery = (data: any) => ({ ...defaultQuery, ...data })

@Component({
  components: {
    draggable,
    PlayPane,
    Pagination,
    Input,
    InputSearch: Input.Search,
    Button
  }
})
export default class ResList extends ViewBase {
  iconMap = iconMap

  get dragGroup() {
    return {
      name: 'playList',
      pull: 'clone',
      revertClone: true,
      put: (to: any, from: any, dragEl: HTMLElement, ev: DragEvent) => {
        if (to == from) {
          return true
        }
        return false
      }
    }
  }

  loading = false

  list: any[] = []

  total = -1

  pageSize = 15

  query: any = { ...defaultQuery }

  oldQuery: any = {}

  resTypeList: IdName[] = []

  cateTypeList: IdName[] = cateTypeList

  generalCateList: IdName[] = []

  generalSubCateMap: MapType<IdName[]> = {}

  phaseList: IdName[] = []

  phaseSubjectMap: MapType<IdName[]> = {}

  gradeList: IdName[] = []

  newKnowCateList: IdName[] = []

  volumeList: IdName[] = []

  keyword = ''

  shrinkSetData = shrinkSetData

  get filterList() {
    const { resType, cateType, generalCate, phase, subject, volume } = this.query

    const list: Filter[] = [
      {
        label: '类型',
        key: 'resType',
        list: this.resTypeList
      }
    ]

    // 3D模型->属性
    resType == 3 &&
      list.push({
        label: '属性',
        key: 'cateType',
        list: this.cateTypeList
      })

    // 3D模型->自然属性->分类
    resType == 3 &&
      cateType == 2 &&
      list.push({
        label: '分类',
        key: 'generalCate',
        list: this.generalCateList
      })

    // !3D模型->学段 || 3D模型->学科属性->学段
    ; (resType != 3 || cateType == 1) &&
      list.push({
        label: '学段',
        key: 'phase',
        list: this.phaseList
      })

    // 3D模型->自然属性->分类->二级分类
    generalCate > 0 &&
      list.push({
        label: '二级分类',
        key: 'generalSubCate',
        list: this.generalSubCateMap[generalCate] || []
      })

    // 学段 -> 学科
    phase > 0 &&
      list.push({
        label: '学科',
        key: 'subject',
        list: this.phaseSubjectMap[phase] || []
      })

    subject > 0 &&
      list.push({
        label: '年级',
        key: 'grade',
        list: this.gradeList
      })

    subject > 0 &&
      phase == 30 &&
      list.push({
        label: '册别',
        key: 'volume',
        list: this.volumeList
      })

    return list.filter(it => (it.list || []).length > 0)
  }

  mounted() {
    this.initCate()
    this.loadResList()
  }

  async initCate() {
    try {
      const { data } = await getCateList()
      this.resTypeList = withAll(data.res_type)
      this.phaseList = withAll(data.phase)
      this.phaseSubjectMap = toMap(data.phase, 'id', 'subject')
    } catch (ex) {
      this.handleError(ex)
    }
  }

  async loadGeneralCateList() {
    try {
      const { data } = await getGeneralCateList()
      this.generalCateList = withAll(data.cate)
      this.generalSubCateMap = toMap(data.cate, 'id', 'subCate')
    } catch (ex) {
      this.handleError(ex)
    }
  }

  async loadSubCateList(phase: number, subject: number) {
    try {
      const { data } = await getSubCateList({
        res_type: this.query.resType,
        phase_id: phase,
        subject_id: subject
      })
      this.gradeList = withAll(data.grade)
      this.newKnowCateList = withAll(data.new_know_cate)
      this.volumeList = withAll(data.volume)
    } catch (ex) {
      this.handleError(ex)
    }
  }

  async loadResList() {
    if (this.loading) {
      return
    }

    this.oldQuery = { ...this.query }

    const {
      resType,
      cateType,
      phase,
      subject,
      generalCate,
      generalSubCate,
      grade,
      newKnowCate,
      volume,
      keyword,
      page
    } = this.query

    const query = {
      res_type: +resType,
      cate_type: +cateType,
      phase_id: +phase,
      subject_id: +subject,
      general_cate_id: generalSubCate > 0 ? +generalSubCate : +generalCate,
      grade_id: +grade,
      new_know_cate_id: +newKnowCate,
      volume_id: +volume,
      key_word: keyword || '',
      page: +page
    }

    this.loading = true
    try {
      const { data } = await queryList(query)
      this.list = data.list.list
      this.total = data.total
      this.pageSize = data.pageSize
    } catch (ex) {
      this.handleError(ex)
    } finally {
      this.loading = false
    }
  }

  gotoDetail(item: any) {
    const link = `/pad/res/${item.id}`
    gotoRoute(link)
  }

  async search() {
    this.query.keyword = this.keyword
  }

  @Watch('query.resType')
  watchResType(resType: number) {
    this.query = makeQuery({ resType })
  }

  @Watch('query.cateType')
  watchCateType(cateType: number) {
    const { resType } = this.query
    this.query = makeQuery({ resType, cateType })
    cateType == 2 && this.loadGeneralCateList()
  }

  @Watch('query.phase')
  watchPhase(phase: number) {
    const { resType, cateType } = this.query
    this.query = makeQuery({ resType, cateType, phase })
  }

  @Watch('query.generalCate')
  watchGeneralCate(generalCate: number) {
    const { resType, cateType, phase } = this.query
    this.query = makeQuery({ resType, cateType, phase, generalCate })
  }

  @Watch('query.generalSubCate')
  watchGeneralSubCate(generalSubCate: number) {
    this.query.generalSubCate = generalSubCate
    this.query.page = 1
  }

  @Watch('query.subject')
  watchSubject(subject: number) {
    this.query.subject = subject
    this.query.grade = 0
    this.query.newKnowCate = 0
    this.query.volume = 0
    this.query.page = 1
    this.loadSubCateList(this.query.phase, subject)
  }

  @Watch('query.grade')
  watchGrade(grade: number) {
    this.query.grade = grade
    this.query.page = 1
  }

  @Watch('query.newKnowCate')
  watchNewKnowCate(newKnowCate: number) {
    this.query.newKnowCate = newKnowCate
    this.query.page = 1
  }

  @Watch('query.newKnowCate')
  watchVolume(volume: number) {
    this.query.volume = volume
    this.query.page = 1
  }

  @Watch('query', { deep: true })
  watchQuery(value: any) {
    if (value.page == this.oldQuery.page) {
      this.query.page = 1
    }
    this.loadResList()
  }
}
